<div class="viewCollectBox">
    <h1>Collected By</h1>
    <br/>
    <div class="grid-item6"> 
        <div class="from-group mt-1" >
        <div class="form-group typeahead-wrap mt-1" style="width:100%"> 
            <strong >Collected By Email<span class="required"> *</span></strong> 
            <input type="text" autocomplete="off" class="form-control mt-2"  minlength="3" [typeahead]="requestorNameDataSource" 
            [typeaheadMinLength]="3" [typeaheadScrollable]="true" [typeaheadItemTemplate]= "requestorCustTemp"
            (typeaheadLoading)="changeRequestorTypeaheadLoading($event)" typeahead-focus-first=true
            (typeaheadOnSelect)="requestorNameOnSelect($event)" (typeaheadNoResults)="typeaheadTravelerNoResults($event)"
            [typeaheadOptionsInScrollableView]="5" typeaheadOptionField="EmployeeFullName" [(ngModel)]="EmployeeFullName"
            name="EmployeeFirstName" #requestorName="ngModel" id="requestorName" autocomplete="off"  [ngModelOptions]="{standalone: true}"
            placeholder="Search by Email ID " (keyup)="searchClient(EmployeeFullName)" required>
            <span ng-bind="EmployeeFullName"></span>

            <img src="../assets/images/spinner.gif" *ngIf="typeaheadRequestorLoading" class="loader">
            <div class="alert alert-danger" style="position: absolute;" [hidden]="!noResultTravelerName">No results found </div>
            <div *ngIf="requestorName.invalid && (requestorName.dirty || requestorName.touched)" class="alert alert-danger">
              <div class="mt-2" *ngIf="requestorName.errors.required" >
                Email ID is required.
              </div>
            </div>

            <ng-template #requestorCustTemp let-model="item" let-index="index">
              <div (click)="onselectClient(model)">
                <span>{{model.displayName}}</span>
                <br>
                <span>{{model.mail}}</span>
              </div>
            </ng-template>
          </div>
    </div>
    </div>
    <br/>
 

    <div class="d-flex justify-content-end" style="margin-top:10px;margin-right: -10px">
        <button  class="button"  (click)="Cancel()" type="button" style="background-color: #53565A;color:#fff">
            Cancel
        </button>
        <button  class="button" (click)="Submit(requestorName.value)" type="button blue" style="background: #007CB0;color:#fff">Submit</button>
    </div>
</div>
